import html2pdf from 'html2pdf.js';
import { queryBot2 } from 'boot/axios';
import { compareFunc, toDataUrl } from 'src/pages/mockup/assistFunc.js';
import NodeBlock from 'pages/mockup/NodeBlock';
import NodeView from 'pages/mockup/NodeView';
import TreeNode from './TreeNode';

export default class extends TreeNode {
    constructor () {
        super();

        this.label = 'Новый док';
        this.innertype = 'doc';
        this.css = null;
        this.activeTab = 'blocks';
        this.activeTabView = 'view';
    }

    getInnerHTML () {
        let result = '';
        let index = 1;
        _.each(this.children, (item) => {
            if (item.visible) {
                if (item.counting) {
                    item.index = index;
                    index += 1;
                }
                if (_.isFunction(item.getInnerHTML)) result += item.getInnerHTML();
            }
        });
        const css = this.css?.content || '';
        result = `<html><body>${result} ${css}</body></html>`;
        return result;
    }

    save () {
        const saveData = {};
        saveData.blocks = [];
        _.each(this.children, (item, index) => {
            const blockData = {};
            blockData.id = item.serverId;
            blockData.visible = item.visible;
            blockData.about = item.about;
            blockData.position = index;
            _.each(item.fields, (field) => {
                blockData[field.key] = field.value;
                if (field.type === 'file' || field.type === 'img') {
                    blockData[field.key] = {
                        value: field.value,
                        filename: field.filename,
                    };
                }
            });
            blockData.activeViewId = item.activeView?.serverId;
            saveData.blocks.push(blockData);
        });
        saveData.cssViewId = this.cssViewId;
        return this.saveData(saveData);
    }

    saveData (saveData) {
        let descr = _.isObject(saveData) ? JSON.stringify(saveData) : String(saveData);
        descr = descr.replaceAll('"', '\'');

        if (!this.serverId) {
            return queryBot2('insert-portfolio-doc', {
                title: this.headline,
                type: this.type,
                descr,
                target: this.target,
                mockupId: this.mockupId ?? 0,
            });
        }
        return queryBot2('update-portfolio-doc', {
            descr,
            type: this.type,
        });
    }

    queryData () {
        return queryBot2('get-portfolio', { type: this.type })
            .then((res) => {
                if (res.data.length > 0) this.initData(_.first(res.data));
            });
    }

    initCSS () {
        const node = this.findChildren('mockup', this.superRoot, 'innertype');
        this.css = node?.css || _.find(node?.children, (item) => item.css?.serverId === this.cssViewId)?.css;
        if (this.css) {
            return Promise.resolve();
        }
        return queryBot2('get-portfolio-css', { viewId: this.cssViewId || -1 })
            .then((res) => {
                const v = new NodeView();
                v.label = 'css';
                this.css = v;
                if (res.data.length === 0) {
                    this.css.save();
                } else {
                    v.initData(res.data[0]);
                }
            });
    }

    initData (data) {
        this.serverId = data.id;
        this.label = data.title;
        this.type = data.type;
        this.target = data.target;
        this.description = data.description;
        this.isPass = data.is_pass;
        this.mockupId = data.mockup_id;
        this.cssViewId = this.dataJSON?.cssViewId;
        this.initCSS();

        let node = this.findChildren('mockup', this.superRoot, 'innertype');
        const templ = _.first(node?.nTemplate?.children);

        _.each(this.dataJSON?.blocks, (block) => {
            const blockNode = this.findChildren(String(block.id), this.superRoot, 'serverId');
            if (!blockNode) return true;
            const b = new NodeBlock();
            b.initData(blockNode.data);
            b.initViews();
            b.position = block.position;
            b.visible = _.isUndefined(block.visible) ? true : block.visible;

            _.each(b.fields, (field) => {
                field.value = _.isObject(block[field.key]) ? block[field.key].value : block[field.key];
                field.filename = _.isObject(block[field.key]) ? block[field.key].filename : block[field.key];
            });

            node = _.find(templ?.children, (item) => item?.fields[0]?.value === b.fields[0]?.value);
            b.about = node?.about || blockNode?.about;
            b.activeViewId = block.activeViewId || b.activeViewId;

            this.addNode(b);
            if (this.children.length === 1) {
                this.activeBlock = b;
            }
            this.children.sort(compareFunc);
            if (_.isFunction(this.tickTree)) this.tickTree();
            return true;
        });
    }

    initDefault (templateId) {
        const node = this.findChildren('mockup', this.superRoot, 'innertype');
        let templ = _.first(node?.nTemplate.children);
        if (templateId) templ = _.find(node?.nTemplate?.children, item => item.serverId === templateId);
        this.mockupId = node.serverId;
        this.target = templ.serverId;
        this.cssViewId = node.dataJSON?.cssViewId;
        this.initCSS();

        _.each(templ.children, (block) => {
            const b = new NodeBlock();
            b.initData(block.data);
            b.initViews();
            b.position = block.position;
            b.visible = _.isUndefined(block.visible) ? true : block.visible;
            b.about = block.about;
            b.fields = block.fields.slice();
            this.addNode(b);

            if (this.children.length === 1) {
                this.activeBlock = b;
            }
        });
        this.children.sort(compareFunc);
        if (_.isFunction(this.tickTree)) this.tickTree();
    }

    getResourceLinkList () {
        const result = [];
        _.each(this.children, (block) => {
            if (block.serverId !== '5') {
                _.each(block.fields, (field) => {
                    if ((field.type === 'img' || field.type === 'file') && field.value) {
                        const { value, filename } = field;
                        result.push({
                            value,
                            filename,
                        });
                    }
                });
            }
        });
        return result;
    }

    get headline () {
        const head = this.findChildren('1', this, 'serverId');
        const field = _.find(head?.fields, (f) => f.tag === 'user.shownname');
        const field2 = _.find(head?.fields, (f) => f.tag === 'course.title');
        if (field && field2) return `${field?.value}, ${field2?.value}`;
        return `Портфолио ${this.type}`;
    }

    saveToHTML () {
        const html = this.getInnerHTML();

        const f = (text, name, type) => {
            const file = new Blob([text], { type });
            const a = document.createElement('a');
            const url = URL.createObjectURL(file);
            a.href = url;
            a.download = name;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 0);
        };

        f(html, `${this.headline}.html`, 'text/plain');
    }

    imagesUrlToBase64 () {
        const res = [];
        _.each(this.children, (block) => {
            _.each(block.fields, async (field) => {
                if (field.type === 'img' && field.value) {
                    res.push(toDataUrl(field.value)
                        .then((v) => {
                            field.value = v;
                        }));
                }
            });
        });
        return Promise.allSettled(res);
    }

    saveToPDF () {
        const opt = {
            margin: 1,
            filename: `${this.headline}.pdf`,
            image: {
                type: 'jpeg',
                quality: 0.9,
            },
            html2canvas: { scale: 1 },
            jsPDF: {
                unit: 'in',
                format: 'letter',
                orientation: 'portrait',
            },
        };
        this.imagesUrlToBase64()
            .then(() => {
                html2pdf(this.getInnerHTML(), opt);
            });
    }
}
